
module.exports = {};
module.exports.url = function() { return window.conf.ge_api; }
module.exports.docReposUrl = function() {return window.conf.doc_repos_url}
module.exports.baseUrl = function() { return window.conf.base_uri; }
